import React, {useEffect, useState} from 'react';
import classnames from 'classnames';
import * as PropTypes from 'prop-types';
import {CSSTransition, TransitionGroup} from 'react-transition-group';
import {connect} from 'react-redux';
import {NavigationDirections} from '../actions/navigation-action-creators';

/**
 * Container for transitioning a group of elements under a div element. Attaches
 * classes based on @prop 'name', to be used in conjuction with AppContainer and / or
 * transition mixin
 */

const TransitionContainer = ({children, className, component, transitionKey, name='component', timeout=1250, processingNavigation}) => {

  useEffect(() => {
    if(processingNavigation) {
      setCurrentPageTransition(processingNavigation);
      setTimeout(() => setCurrentPageTransition(false), timeout);
    }
  }, [processingNavigation]);

  const [ currentPageTransition, setCurrentPageTransition ] = useState(false);
  const containerClasses = classnames(
    className,
    'transition-container',
  );
  const transitionClasses = classnames(
    `transition-for-${name}`,
    {
      ['transition-content--reverse']: currentPageTransition === NavigationDirections.BACK,
      ['transition-content--forward']: currentPageTransition === NavigationDirections.FORWARD
    },
    name
  );

  return <TransitionGroup className={containerClasses} {...component && {component}}>
    <CSSTransition key={transitionKey} classNames={transitionClasses} timeout={timeout}>
      { children }
    </CSSTransition>
  </TransitionGroup>;
};

TransitionContainer.propTypes = {
  className: PropTypes.string.isRequired,
  component: PropTypes.string,
  transitionKey: PropTypes.string,
  name: PropTypes.string,
  timeout: PropTypes.number,
  children: PropTypes.any,
  processingNavigation: PropTypes.any,
};

export default connect( state => {
  const processingNavigation = state.processingNavigation || false;
  return {
    processingNavigation
  };
})(TransitionContainer);
